import React from 'react';

export function EmptyState({ icon, title, description, action }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '48px 24px', textAlign: 'center', gap: 12
    }}>
      <div style={{ fontSize: 48, marginBottom: 4 }}>{icon}</div>
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--nc-text)' }}>{title}</div>
      <div className="nc-body-sm" style={{ maxWidth: 260, lineHeight: 1.5 }}>{description}</div>
      {action && <div style={{ marginTop: 8 }}>{action}</div>}
    </div>
  );
}
